export const slideToIndexSelector = () => (state) => state.slideToIndex;
